module.exports = __webpack_public_path__ + "images/boatyard_logo_true_north.c072345424204f7776db4afec51a4bef.png";